<template>
  <div class="h-100">
    <profile-bubble class="position-absolute" style="top: 10px; right: 10px" />
    <router-view class="h-100" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { FETCH, GET, LISTEN } from "@/store/actions";

import ProfileBubble from "@/components/Auth/Profile/Bubble";

export default {
  name: "Project",
  components: { ProfileBubble },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    },
  },
  mounted() {
    const { projectId } = this;

    this.getSettings({ projectId });
    this.listenSettings({ projectId });

    this.getBilling({ projectId });
    this.listenBilling({ projectId });

    this.fetchUsers({ projectId });
    this.listenUsers({ projectId });

    this.fetchUsersInvites({ projectId });
    this.listenUsersInvites({ projectId });

    this.fetchResources({ projectId });
  },
  methods: {
    ...mapActions("projectsBilling", { getBilling: GET, listenBilling: LISTEN }),
    ...mapActions("projectsSettings", { getSettings: GET, listenSettings: LISTEN }),
    ...mapActions("projectsUsers", { fetchUsers: FETCH, listenUsers: LISTEN }),
    ...mapActions("projectsUsersInvites", { fetchUsersInvites: FETCH, listenUsersInvites: LISTEN }),
    ...mapActions("projectsResources", { fetchResources: FETCH }),
  },
};
</script>
